<template>
  <MainSliderBrand v-if="brands.length === 0" />

  <section v-else class="recommend-brands-section dosiin_mb-16 page-section">
    <h2 class="section-title" v-text="title"></h2>
    <div class="dosiin_position-relative">
      <Swiper
        class="dosiin_recommend-brands_swiper recommend-brands_swiper dosiin_position-unset overflow"
        :modules="modules"
        :slidesPerView="options.slidesPerView"
        :centeredSlides="options.centeredSlides"
        :navigation="options.navigation"
        :loop="options.loop"
        :autoplay="options.autoplay"
        :spaceBetween="options.spaceBetween"
      >
        <SwiperSlide class="swiper-slide" v-for="(brand, i) in brands" :key="i">
          <div class="suggest-brand-slider">
            <div class="suggest-brand-shop">
              <div class="shops-brand-infomation">
                <BrandLogo :width="163" :height="163" :brand="brand" />
                <h2 class="dosiin_mt-2" v-text="brand.company"></h2>
                <div class="brand-flow">
                  <b>{{ brand.follow_count }}</b
                  >người theo dõi
                </div>
              </div>
              <ul class="shops-brand-social">
                <li>
                  <router-link :to="_brandUrl(brand.seo_name)" :title="brand.company">
                    <article class="brand-shop-social_item">
                      <h6 v-text="brand.products_count"></h6>
                      <p>
                        <svg
                          width="17"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M3.23876 1.48742C3.25571 1.45067 3.30089 1.40119 3.3392 1.37741C3.40342 1.33757 3.80261 1.33416 8.48175 1.33353C13.4224 1.33285 13.6627 1.32725 13.7161 1.42436C13.7217 1.43462 13.7253 1.44603 13.732 1.45872C13.7459 1.48468 14.0744 2.39401 14.462 3.47941L15.1666 5.45288L15.1662 5.70414C15.1654 6.161 15.0448 6.5274 14.8142 6.77394C14.6225 6.97889 14.425 7.08619 14.1185 7.15197L14.0469 7.16734V10.8116C14.0469 13.3764 14.0385 14.4742 14.0186 14.5178C14.0031 14.5519 13.9573 14.5994 13.9169 14.6232C13.8491 14.6633 13.4387 14.6666 8.49998 14.6666C3.56123 14.6666 3.15089 14.6633 3.08305 14.6232C3.04266 14.5994 2.99691 14.5519 2.98136 14.5178C2.96146 14.4742 2.9531 13.3779 2.9531 10.817V7.17822L2.77732 7.14515C2.20925 7.03819 1.83514 6.46693 1.83376 5.70432L1.83331 5.45327L2.52063 3.50373C2.89865 2.43148 3.22183 1.52414 3.23876 1.48742ZM5.16665 7.14994C4.83344 7.14994 4.67542 7.10619 4.42446 6.94444C4.35284 6.89829 4.24152 6.8074 4.17706 6.74248L4.05988 6.62446L3.88659 6.78615C3.79131 6.87506 3.66532 6.96949 3.60665 6.99595L3.49998 7.04405V10.5819V14.1197H8.49998H13.5V10.6103V7.10093L13.3633 7.03827C13.285 7.00238 13.1579 6.90704 13.0659 6.81511L12.9053 6.65461L12.8055 6.75821C12.6789 6.88962 12.4888 7.01145 12.289 7.08916C12.1577 7.14028 12.0851 7.14994 11.8333 7.14994C11.5815 7.14994 11.509 7.14028 11.3776 7.08916C11.1731 7.0096 10.9884 6.88928 10.845 6.74214L10.7291 6.62326L10.5639 6.77785C10.012 7.29409 9.18238 7.29151 8.6505 6.77191L8.49998 6.62487L8.34576 6.77579C7.81811 7.29211 6.98678 7.29302 6.4361 6.77785L6.27084 6.62326L6.15495 6.74214C6.01152 6.88928 5.82683 7.0096 5.62238 7.08916C5.491 7.14028 5.41844 7.14994 5.16665 7.14994ZM8.14528 8.11463C7.62166 8.24169 7.24843 8.6733 7.24692 9.15347C7.24642 9.30566 7.25976 9.36225 7.32949 9.50392C7.41838 9.68447 7.62778 9.91383 7.83192 10.0543L7.95311 10.1377V10.4444V10.7512L7.69921 10.7835C6.93103 10.881 6.20236 11.135 5.67205 11.4899C5.41809 11.6599 5.07939 11.997 4.95285 12.2058C4.81421 12.4345 4.71827 12.74 4.71426 12.9654C4.71116 13.1388 4.71645 13.1581 4.78741 13.2323C4.9252 13.3765 5.15569 13.3292 5.23452 13.1405C5.2545 13.0927 5.27082 13.0119 5.27082 12.961C5.27082 12.7102 5.49502 12.3393 5.79119 12.1C6.43624 11.5788 7.37916 11.3005 8.49999 11.3005C9.62082 11.3005 10.5637 11.5788 11.2088 12.1C11.505 12.3393 11.7292 12.7102 11.7292 12.961C11.7292 13.0829 11.787 13.2171 11.8624 13.2699C11.8957 13.2933 11.971 13.3124 12.0295 13.3124C12.1145 13.3124 12.1516 13.2962 12.2126 13.2323C12.2835 13.1581 12.2888 13.1388 12.2857 12.9654C12.2817 12.74 12.1858 12.4345 12.0471 12.2058C11.995 12.1197 11.8581 11.9541 11.7431 11.8376C11.1178 11.205 10.0656 10.8099 8.83004 10.7439L8.49999 10.7262V10.3063C8.49999 10.0127 8.50041 9.89689 8.44696 9.81724C8.41159 9.76454 8.35263 9.72767 8.25434 9.66559C8.0621 9.54418 7.83267 9.31076 7.80767 9.21115C7.7428 8.95268 8.07699 8.64168 8.42197 8.63952C8.68314 8.63788 8.84319 8.80153 8.8859 9.11393C8.91296 9.3118 8.96778 9.39582 9.09462 9.43381C9.17762 9.45868 9.20864 9.45658 9.27676 9.42134C9.40059 9.3573 9.44483 9.27133 9.44095 9.10229C9.42499 8.41047 8.8216 7.95051 8.14528 8.11463Z"
                            fill="#B3B3B3"
                          ></path>
                        </svg>
                        <span>Sản phẩm</span>
                      </p>
                    </article>
                  </router-link>
                </li>
                <li>
                  <router-link :to="_brandUrl(brand.seo_name)" :title="brand.company">
                    <article class="brand-shop-social_item">
                      <h6>{{ parseInt(brand.discussion.average_rating) }}/5</h6>
                      <p>
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14.6107 6.48563C14.547 6.2872 14.4297 6.11034 14.272 5.97462C14.1143 5.8389 13.9222 5.74962 13.717 5.71667L10.4973 5.1917L9.00475 2.28177C8.90968 2.09652 8.76558 1.94113 8.58827 1.83264C8.41096 1.72414 8.20729 1.66675 7.99961 1.66675C7.79193 1.66675 7.58826 1.72414 7.41095 1.83264C7.23364 1.94113 7.08954 2.09652 6.99447 2.28177L5.50192 5.1917L2.28228 5.71667C2.0773 5.75014 1.88547 5.83961 1.72783 5.97527C1.5702 6.11093 1.45286 6.28752 1.38868 6.48569C1.3245 6.68385 1.31597 6.89592 1.36402 7.09863C1.41206 7.30133 1.51484 7.48685 1.66106 7.63481L3.95828 9.9582L3.46106 13.1925C3.42915 13.3986 3.45449 13.6094 3.53429 13.8019C3.61409 13.9944 3.74526 14.1611 3.91337 14.2836C4.08147 14.4061 4.28001 14.4798 4.48714 14.4965C4.69427 14.5131 4.90197 14.4721 5.08739 14.378L7.99961 12.904L10.9119 14.378C11.0974 14.472 11.305 14.5128 11.512 14.496C11.7191 14.4793 11.9175 14.4056 12.0856 14.2831C12.2536 14.1606 12.3848 13.994 12.4646 13.8016C12.5445 13.6093 12.57 13.3985 12.5382 13.1925L12.041 9.9582L14.3382 7.63481C14.4849 7.48714 14.588 7.30162 14.6361 7.0988C14.6842 6.89597 14.6754 6.68375 14.6107 6.48563Z"
                            fill="#B3B3B3"
                          ></path>
                        </svg>
                        <span>Đánh giá</span>
                      </p>
                    </article>
                  </router-link>
                </li>
                <li>
                  <router-link :to="_brandUrl(brand.seo_name)" :title="brand.company">
                    <article class="brand-shop-social_item">
                      <h6>{{ _momentFromNow(brand.timestamp) }}</h6>
                      <p>
                        <svg
                          width="17"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M4.82609 1.33325C4.6785 1.33325 4.52804 1.3864 4.42149 1.49113C4.31494 1.59586 4.26087 1.74375 4.26087 1.88881V2.44436H2.56522C2.41763 2.44436 2.26718 2.49751 2.16062 2.60224C2.05407 2.70697 2 2.85486 2 2.99992V5.22214V14.111C2 14.2561 2.05407 14.404 2.16062 14.5087C2.26718 14.6134 2.41763 14.6666 2.56522 14.6666H14.4348C14.5824 14.6666 14.7328 14.6134 14.8394 14.5087C14.9459 14.404 15 14.2561 15 14.111V5.22214V2.99992C15 2.85486 14.9459 2.70697 14.8394 2.60224C14.7328 2.49751 14.5824 2.44436 14.4348 2.44436H12.7391V1.88881C12.7391 1.74375 12.6851 1.59586 12.5785 1.49113C12.472 1.3864 12.3215 1.33325 12.1739 1.33325H11.6087C11.4611 1.33325 11.3107 1.3864 11.2041 1.49113C11.0975 1.59586 11.0435 1.74375 11.0435 1.88881V2.44436H5.95652V1.88881C5.95652 1.74375 5.90245 1.59586 5.7959 1.49113C5.68935 1.3864 5.53889 1.33325 5.3913 1.33325H4.82609ZM4.82609 1.88881H5.3913V3.55547H4.82609V1.88881ZM11.6087 1.88881H12.1739V2.67548C12.1689 2.70548 12.1689 2.73609 12.1739 2.76609V3.55547H11.6087V1.88881ZM2.56522 2.99992H4.26087V3.55547C4.26087 3.70054 4.31494 3.84842 4.42149 3.95315C4.52804 4.05788 4.6785 4.11103 4.82609 4.11103H5.3913C5.53889 4.11103 5.68935 4.05788 5.7959 3.95315C5.90245 3.84842 5.95652 3.70054 5.95652 3.55547V2.99992H11.0435V3.55547C11.0435 3.70054 11.0975 3.84842 11.2041 3.95315C11.3107 4.05788 11.4611 4.11103 11.6087 4.11103H12.1739C12.3215 4.11103 12.472 4.05788 12.5785 3.95315C12.6851 3.84842 12.7391 3.70054 12.7391 3.55547V2.99992H14.4348V4.94436H2.56522V2.99992ZM2.56522 5.49992H14.4348V14.111H2.56522V5.49992ZM6.51732 6.60723C6.50382 6.60755 6.49035 6.60882 6.47703 6.61103H4.54348C4.46853 6.61104 4.39665 6.64031 4.34365 6.6924C4.29065 6.74449 4.26088 6.81514 4.26087 6.88881V8.78659C4.25583 8.81659 4.25583 8.8472 4.26087 8.8772V10.731C4.25583 10.761 4.25583 10.7916 4.26087 10.8216V12.7221C4.26088 12.7958 4.29065 12.8665 4.34365 12.9186C4.39665 12.9706 4.46853 12.9999 4.54348 12.9999H6.47427C6.50479 13.0049 6.53593 13.0049 6.56645 12.9999H8.45253C8.48305 13.0049 8.51419 13.0049 8.54471 12.9999H9.91304H10.4308C10.4613 13.0049 10.4925 13.0049 10.523 12.9999H12.4565C12.5315 12.9999 12.6033 12.9706 12.6563 12.9186C12.7093 12.8665 12.7391 12.7958 12.7391 12.7221V10.8244C12.7442 10.7944 12.7442 10.7637 12.7391 10.7338V8.87991C12.7442 8.84991 12.7442 8.8193 12.7391 8.78931V6.88881C12.7391 6.81514 12.7093 6.74449 12.6563 6.6924C12.6033 6.64031 12.5315 6.61104 12.4565 6.61103H10.5257C10.4952 6.60607 10.4641 6.60607 10.4336 6.61103H8.54747C8.51695 6.60607 8.48581 6.60607 8.45529 6.61103H6.56921C6.55207 6.6082 6.5347 6.60693 6.51732 6.60723ZM4.82609 7.16659H6.23913V8.55547H4.82609V7.16659ZM6.80435 7.16659H8.21739V8.55547H6.80435V7.16659ZM8.78261 7.16659H10.1957V8.55547H8.78261V7.16659ZM10.7609 7.16659H12.1739V8.55547H10.7609V7.16659ZM4.82609 9.11103H6.23913V10.4999H4.82609V9.11103ZM6.80435 9.11103H8.21739V10.4999H6.80435V9.11103ZM8.78261 9.11103H10.1957V10.4999H8.78261V9.11103ZM10.7609 9.11103H12.1739V10.4999H10.7609V9.11103ZM4.82609 11.0555H6.23913V12.4444H4.82609V11.0555ZM6.80435 11.0555H8.21739V12.4444H6.80435V11.0555ZM8.78261 11.0555H10.1957V12.4444H9.91304H8.78261V11.0555ZM10.7609 11.0555H12.1739V12.4444H10.7609V11.0555Z"
                            fill="#B3B3B3"
                          ></path>
                        </svg>
                        <span>Tham gia</span>
                      </p>
                    </article>
                  </router-link>
                </li>
              </ul>
              <div class="suggest_btn-follow">
                <router-link
                  :to="_brandUrl(brand.seo_name)"
                  :title="brand.company"
                  class="brand_follow-btn primary-button button"
                >
                  <i class="dsi dsi-act-manage"></i>
                  <span class="follow-btn-text">Ghé shop</span>
                </router-link>
              </div>
            </div>
            <div class="suggest-brand-image">
              <router-link :to="_brandUrl(brand.seo_name)" :title="brand.company">
                <img
                  v-lazy="{
                    src: _brandBannerCrop(
                      brand.banner_shop[Object.keys(brand.banner_shop)[0]]
                    ),
                    loading: _bannerDefault,
                    error: _bannerDefault,
                  }"
                  class="dosiin_w-100 styled-img"
                />
              </router-link>
            </div>
          </div>
        </SwiperSlide>

        <div
          class="swiper-button-next dosiin_swiper-button dosiin_position-button-next"
        ></div>
        <div
          class="swiper-button-prev dosiin_swiper-button dosiin_position-button-prev"
        ></div>
      </Swiper>
    </div>
  </section>
</template>

<script>
import { toRefs, ref } from "vue";
import MainSliderBrand from "@/components/skeletons/sliders/MainSliderBrand";
import { Autoplay, Navigation } from "swiper";

export default {
  components: {
    MainSliderBrand,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    brands: {
      type: Array,
      default: [],
    },
  },
  setup(props) {
    const options = {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: true,
      speed: 1000,
      centeredSlides: true,
      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    };

    return {
      options,
      ...toRefs(props),
      modules: [Autoplay, Navigation],
    };
  },
};
</script>
